<template>
  <div>
    <label>{{ statusMessage }}</label>
    <table class="table">
      <thead>
      <tr>
        <th>Report ID</th>
        <th>Name</th>
        <th>Type</th>
        <th>From</th>
        <th>To</th>
        <th>Report Created</th>
        <th>Actions</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="report in computedData" >
        <td>{{ report.id }}</td>
        <td>{{ report.name }}</td>
        <td>{{ report.report_type }}</td>
        <td>{{ report.report_from_date }}</td>
        <td>{{ report.report_to_date }}</td>
        <td>{{ report.created_at }}</td>
        <td>
          <a class="btn btn-xs btn-default" @click="sendEmail($event,report.id)" >Email Report</a>
          <a class="btn btn-xs btn-default" @click="downloadReport($event,report.id)" >Download</a>
          <a class="btn btn-xs btn-default" @click="deleteReport($event,report.id)" >Delete</a>
        </td>
      </tr>
      </tbody>
    </table>
    <report-transaction-send-modal
      :show-confirm="showConfirm" 
      confirm-message="Do you want to email this report?"
      @ok="confirmReport"
      @cancel="cancelReport"
      :email-prop="userEmail"
      :message-prop="modalMessage"
    ></report-transaction-send-modal>
    <confirm-modal 
      :show-confirm="showConfirmDelete"
      confirm-message="Do you want to delete this report?"
      @ok="confirmDeleteReport"
      @cancel="cancelDeleteReport">
    </confirm-modal>
  </div>
</template>

<script>
import axios from "axios";
import ReportTransactionSendModal from "./ReportTransactionSendModal.vue";
import ConfirmModal from "../ConfirmModal";

export default {
  name: "ReportsIndex",
  components: {
    ReportTransactionSendModal, ConfirmModal
  },
  props: {
    reportData: Array,
    userEmail: String,
    default: []
  },
  data() {
    return {
      showConfirm: false,
      showConfirmDelete: false,
      statusMessage: '',
      modalMessage: '',
      formData: {
        reportId: 0,
      },
      showStatusMessage: false,
      reports: this.reportData,
    }
  },
  computed: {
    computedData() {
      let report = []
      report = this.reports
      return report
    },
  },
  methods: {
    sendEmail(event,id) {
      event.preventDefault()
      this.showConfirm = true
      this.formData.reportId = id
      this.timer()
    },
    sendReport(email) {
      this.statusMessage = '';

      axios.post('crm2/sendTranscations', {
        ...this.formData,
        email
      })
          .then(response => {
            this.showConfirm = false
            this.statusMessage = response.data.statusMessage
            this.reports = response.data.reportEvents
            this.modalMessage = ''
            this.timer()
            return Promise.resolve()
          })

    },
    downloadReport(event, id) {
      event.preventDefault()
      axios.post('crm2/downloadTranscations', {
        reportId: id
      })
        .then(response => {
          const blob = new Blob([response.data]);
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = 'Transactions Report.csv';
          link.click();
          window.URL.revokeObjectURL(url);
        })
    },
    deleteReport(event, id) {
      event.preventDefault()
      this.formData.reportId = id
      this.showConfirmDelete = true
    },
    confirmDeleteReport: function () {
      this.showConfirmDelete = false
      this.statusMessage = "Your report is being deleted."
      this.showStatusMessage = true
      axios.post('crm2/deleteTranscationReport', {
        reportId: this.formData.reportId
      })
        .then(response => {
          this.statusMessage = response.data.statusMessage
          this.reports = response.data.reportEvents
          this.showConfirmDelete = false
          this.timer()
          return Promise.resolve()
        })
    },
    cancelDeleteReport: function () {
      this.showConfirmDelete = false
      this.statusMessage = "Deleting of your report has been cancelled."
      this.showStatusMessage = true
      this.timer()
    },
    confirmReport: function (email) {
      const emailRegex =  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

      if (!emailRegex.test(email)) {
        this.modalMessage = 'Invalid email address';
        return;
      }

      this.statusMessage = "Your report is being emailed."
      this.showStatusMessage = true
      this.sendReport(email)
      this.timer()
    },
    cancelReport: function () {
      this.showConfirm = false
      this.statusMessage = "Emailing of your report has been cancelled."
      this.showStatusMessage = true
      this.modalMessage = ''
      this.timer()
    },
    timer() {
      setTimeout(() => {
        this.showStatusMessage = false
        this.statusMessage = ''
      }, 5000)
    },
  }
}
</script>